export const toggleSidebar = () => {
    if (document.querySelector(".sidebar").classList.contains("toggled")) {
        document.querySelector(".sidebar").classList.remove("toggled")
    } else {
        document.querySelector(".sidebar").classList.add("toggled")
    }
};
